import React, { useState, useEffect } from "react";
import { Navbar, Nav, NavDropdown, Container, Row, Col } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestion, faFeed } from "@fortawesome/free-solid-svg-icons";
import PopupModal from "../components/Modal/PopupModal";
import { Link } from "react-router-dom";
// import ToolTip from "./ToolTip";
import "./header.css";

const Headers = () => {
  const [getPopUpShow, setPopUpShow] = useState(false);
  const [expanded, setExpanded] = useState(false);

  const onhide = () => {
    setPopUpShow(false);
  };

  const handelclick = () => {
    setPopUpShow(true);
    setExpanded(false);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      const navbar = document.querySelector('.navbar-collapse');
      const toggler = document.querySelector('.navbar-toggler');
      
      if (navbar && toggler && 
          !navbar.contains(event.target) && 
          !toggler.contains(event.target) &&
          expanded) {
        setExpanded(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, [expanded]);

  // Handle navigation link clicks
  const handleNavClick = () => {
    setExpanded(false);
  };

  return (
    <Navbar 
      expand="md" 
      bg="white" 
      className="p-0 headers fixed-top"
      expanded={expanded}
      onToggle={setExpanded}
    >
      <PopupModal show={getPopUpShow} onHide={onhide} />
      
      <Navbar.Brand className="logoSize">
        <Link to="/" onClick={handleNavClick}>
          <img
            className="img-fluid"
            src="./assets/images/logo.png"
            alt="logo"
          />
        </Link>
      </Navbar.Brand>
      
      <Navbar.Toggle aria-controls="navbarNav" className="mr-3" />
      
      <Navbar.Collapse id="navbarNav">
        <Nav className="ml-auto">
          {/* Company Dropdown */}
          <NavDropdown
            title="Company"
            id="navbarDropdown1"
            className="nav-link"
          >
            <Container>
              <Row>
                {/* About Us */}
                <Col md={4}>
                  <div className="d-flex tab" onClick={handleNavClick}>
                    <div className="fa-icon text-center">
                      <i className="bi bi-buildings-fill"></i>
                    </div>
                    <div className="d-flex flex-column">
                      <NavDropdown.Item>
                        <Link to="about" className="router-link">
                          <h6 className="mb-0">About Us</h6>
                        </Link>
                        <small className="text-muted">What we stand for</small>
                      </NavDropdown.Item>
                    </div>
                  </div>
                </Col>

                {/* Our Culture */}
                {/* <Col md={4}>
                  <div className="d-flex tab" onClick={handleNavClick}>
                    <div className="fa-icon text-center">
                      <i className="bi bi-people-fill"></i>
                    </div>
                    <div className="d-flex flex-column">
                      <NavDropdown.Item>
                        <Link to="our-culture" className="router-link">
                          <h6 className="mb-0">Our Culture</h6>
                        </Link>
                        <small className="text-muted">
                          Where innovation meets passion
                        </small>
                      </NavDropdown.Item>
                    </div>
                  </div>
                </Col> */}

                {/* Our Success */}
                <Col md={4}>
                  <div className="d-flex tab" onClick={handleNavClick}>
                    <div className="fa-icon text-center">
                      <i className="bi bi-columns-gap"></i>
                    </div>
                    <div className="d-flex flex-column">
                      <NavDropdown.Item>
                        <Link to="our-success" className="router-link">
                          <h6 className="mb-0">Our Success</h6>
                        </Link>
                        <small className="text-muted">
                          Committed to Growth
                        </small>
                      </NavDropdown.Item>
                    </div>
                  </div>
                </Col>
                {/* Our Success */}
                <Col md={4}>
                  <div className="d-flex tab" onClick={handleNavClick}>
                    <div className="fa-icon text-center">
                      <i className="bi-award-fill"></i>
                    </div>
                    <div className="d-flex flex-column">
                      <NavDropdown.Item>
                        <Link to="Leadership" className="router-link">
                          <h6 className="mb-0">Leadership</h6>
                        </Link>
                        <small className="text-muted">
                          Inspiring Growth & Innovation
                        </small>
                      </NavDropdown.Item>
                    </div>
                  </div>
                </Col>
              </Row>
            </Container>
          </NavDropdown>

          {/* Product Dropdown */}
          <NavDropdown
            title="Product"
            id="navbarDropdown2"
            className="nav-link"
          >
            <Container>
              <Row>
                <Col md={4}>
                  <div className="d-flex tab" onClick={handleNavClick}>
                    <div className="fa-icon text-center">
                      <i className="bi bi-truck fs-2 icon-widths"></i>
                    </div>
                    <div className="d-flex flex-column">
                      <NavDropdown.Item>
                        <Link
                          to="product#vendoremanagement"
                          className="router-link"
                        >
                          <h6 className="mb-0">Purchase Partner Management</h6>
                        </Link>
                        <small className="text-muted">
                          Efficiently manage and collaborate with business
                          partners using a robust, automated platform.
                        </small>
                      </NavDropdown.Item>
                    </div>
                  </div>
                </Col>

                <Col md={4}>
                  <div className="d-flex tab" onClick={handleNavClick}>
                    <div className="fa-icon text-center">
                      <i className="bi bi-person fs-2 icon-widths"></i>
                    </div>
                    <div className="d-flex flex-column">
                      <NavDropdown.Item>
                        <Link to="product#sourcetopay" className="router-link">
                          <h6 className="mb-0">Customer Sales Management</h6>
                        </Link>
                        <small className="text-muted">
                          Manage and automate the complete order-to-cash process
                          with a robust sales operations management system.
                        </small>
                      </NavDropdown.Item>
                    </div>
                  </div>
                </Col>

                <Col md={4}>
                  <div className="d-flex tab" onClick={handleNavClick}>
                    <div className="fa-icon text-center">
                      <i className="bi bi-building fs-2 icon-widths"></i>
                    </div>
                    <div className="d-flex flex-column">
                      <NavDropdown.Item>
                        <Link
                          to="product#sourcetocontract"
                          className="router-link"
                        >
                          <h6 className="mb-0">Asset Management</h6>
                        </Link>
                        <small className="text-muted">
                          Track and manage all your assets in real time through
                          a powerful, feature-rich platform.
                        </small>
                      </NavDropdown.Item>
                    </div>
                  </div>
                </Col>

                <Col md={4}>
                  <div className="d-flex tab" onClick={handleNavClick}>
                    <div className="fa-icon text-center">
                      <i className="bi-gear-wide-connected icon-widths"></i>
                    </div>
                    <div className="d-flex flex-column">
                      <NavDropdown.Item>
                        <Link
                          to="product#procuretoorder"
                          className="router-link"
                        >
                          <h6 className="mb-0">Production Management</h6>
                        </Link>
                        <small className="text-muted">
                          Oversees and automates manufacturing processes.
                        </small>
                      </NavDropdown.Item>
                    </div>
                  </div>
                </Col>

                <Col md={4}>
                  <div className="d-flex tab" onClick={handleNavClick}>
                    <div className="fa-icon text-center">
                      <i className="bi-file-earmark-text icon-widths"></i>
                    </div>
                    <div className="d-flex flex-column">
                      <NavDropdown.Item>
                        <Link
                          to="product#supplychainstrategy"
                          className="router-link"
                        >
                          <h6 className="mb-0">AP Automation</h6>
                        </Link>
                        <small className="text-muted">
                          Digitizes invoice approvals and automated payment
                          processing.
                        </small>
                      </NavDropdown.Item>
                    </div>
                  </div>
                </Col>

                <Col md={4}>
                  <div className="d-flex tab" onClick={handleNavClick}>
                    <div className="fa-icon text-center">
                      <i className="bi-boxes icon-widths"></i>
                    </div>
                    <div className="d-flex flex-column">
                      <NavDropdown.Item>
                        <Link to="product#Analytics" className="router-link">
                          <h6 className="mb-0">Product Hub and Life Cycle</h6>
                        </Link>
                        <small className="text-muted">
                          Centralizes all data related to a product's lifecycle.
                        </small>
                      </NavDropdown.Item>
                    </div>
                  </div>
                </Col>

                <Col md={4}>
                  <div className="d-flex tab" onClick={handleNavClick}>
                    <div className="fa-icon text-center">
                      <i className="bi-truck-front icon-widths"></i>
                    </div>
                    <div className="d-flex flex-column">
                      <NavDropdown.Item>
                        <Link to="product#Analytics" className="router-link">
                          <h6 className="mb-0">Logistics Management</h6>
                        </Link>
                        <small className="text-muted">
                          Automates transportation and supply chain movement.
                        </small>
                      </NavDropdown.Item>
                    </div>
                  </div>
                </Col>

                <Col md={4}>
                  <div className="d-flex tab" onClick={handleNavClick}>
                    <div className="fa-icon text-center">
                      <i className="bi-box icon-widths"></i>
                    </div>
                    <div className="d-flex flex-column">
                      <NavDropdown.Item>
                        <Link to="product#Analytics" className="router-link">
                          <h6 className="mb-0">Supply Inventory Management</h6>
                        </Link>
                        <small className="text-muted">
                          Monitor and manage inventory from anywhere with a
                          smart, cloud-based inventory management module.
                        </small>
                      </NavDropdown.Item>
                    </div>
                  </div>
                </Col>

                <Col md={4}>
                  <div className="d-flex tab" onClick={handleNavClick}>
                    <div className="fa-icon text-center">
                      <i className="bi-currency-rupee icon-widths"></i>
                    </div>
                    <div className="d-flex flex-column">
                      <NavDropdown.Item>
                        <Link to="product#Analytics" className="router-link">
                          <h6 className="mb-0">Profit Ledger</h6>
                        </Link>
                        <small className="text-muted">
                          Optimizes financial visibility and operational
                          profitability.
                        </small>
                      </NavDropdown.Item>
                    </div>
                  </div>
                </Col>
              </Row>
            </Container>
          </NavDropdown>

          {/* Industries Link */}
          <Nav.Link 
            as={Link} 
            to="/industries" 
            className="nav-link pricing-link"
            onClick={handleNavClick}
          >
            Industries
          </Nav.Link>

          {/* Pricing Link */}
          <Nav.Link 
            as={Link} 
            to="/pricing" 
            className="nav-link pricing-link"
            onClick={handleNavClick}
          >
            Pricing
          </Nav.Link>

          {/* Contact-Us Dropdown */}
          <NavDropdown
            title="Contact-Us"
            id="navbarDropdown3"
            className="nav-link"
          >
            <Container>
              <Row>
                <Col md={4}>
                  <div className="d-flex tab" onClick={handleNavClick}>
                    <div className="fa-icon text-center">
                      <i className="bi bi-hand-index"></i>
                    </div>
                    <div className="d-flex flex-column">
                      <NavDropdown.Item>
                        <Link to="getintotouch" className="router-link">
                          <h6 className="mb-0">Get in touch</h6>
                        </Link>
                        <small className="text-muted">
                          Let's Build Together
                        </small>
                      </NavDropdown.Item>
                    </div>
                  </div>
                </Col>

                <Col md={4}>
                  <div className="d-flex tab" onClick={handleNavClick}>
                    <div className="fa-icon text-center">
                      <FontAwesomeIcon icon={faFeed} />
                    </div>
                    <div className="d-flex flex-column">
                      <NavDropdown.Item>
                        <Link to="feedback" className="router-link">
                          <h6 className="mb-0">Feedback</h6>
                        </Link>
                        <small className="text-muted">
                          Opinions, Complaints
                        </small>
                      </NavDropdown.Item>
                    </div>
                  </div>
                </Col>

                <Col md={4}>
                  <div className="d-flex tab" onClick={handleNavClick}>
                    <div className="fa-icon text-center">
                      <FontAwesomeIcon icon={faQuestion} />
                    </div>
                    <div className="d-flex flex-column">
                      <NavDropdown.Item>
                        <Link to="askus" className="router-link">
                          <h6 className="mb-0">Ask Us</h6>
                        </Link>
                        <small className="text-muted">Qns and Answers</small>
                      </NavDropdown.Item>
                    </div>
                  </div>
                </Col>
              </Row>
            </Container>
          </NavDropdown>
        </Nav>

        {/* Right Side Buttons */}
        <div className="m-2 d-flex align-items-center">
          {/* <ToolTip /> */}
          <button className="main-btn" onClick={handelclick}>
            Book a Demo
          </button>
        </div>
      </Navbar.Collapse>
    </Navbar>
  );
};

export default Headers;
